import axios from "axios";
import { MessageBox, Message } from "element-ui";
// import store from "@/store";
// import { getToken } from "@/utils/auth";
// import router from "@/router";
// create an axios instance
import errorCode from '@/utils/errorCode'

export const request = axios.create({

  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
});
// request interceptor
request.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const token = sessionStorage.getItem("token");
    if (token && token != null) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
request.interceptors.response
  .use(res => {
    if (res) {
      // 未设置状态码则默认成功状态
      const code = res.data.code || 200;
      // 获取错误信息
      const msg = errorCode[code] || res.data.msg || errorCode['default']
      if (code === 401) {
        if (!isReloginShow) {
          isReloginShow = true;
          MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            isReloginShow = false;
            store.dispatch('LogOut').then(() => {
              // 如果是登录页面不需要重新加载
              if (window.location.hash.indexOf("#/login") != 0) {
                location.href = '/index';
              }
            })
          }).catch(() => {
            isReloginShow = false;
          });
        }
        return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
      } else if (code === 500) {
        Message({
          message: msg,
          type: 'error'
        })
        return Promise.reject(new Error(msg))
      } else if (code !== 200) {
        Notification.error({
          title: msg
        })
        return Promise.reject('error')
      } else {
        return res
      }
    }
  },
    error => {
      let { message } = error;
      console.log(error, message);
      if (message == "Network Error") {
        message = "后端接口连接异常";
      } else if (message.includes("timeout")) {
        message = "系统接口请求超时";
      } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.substr(message.length - 3) + "异常";
      }
      Message.closeAll();
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  )
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
 */

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
// (response) => {
//   return response;
// },
// (error) => {
//   var res = error.response;
//   if (res) {
//     switch (res.status) {
//       case 302:
//         Message({
//           message: "登录超时，请重新登录",
//           type: "error",
//         });
//         router.push({ path: "/login" });
//         break;
//       case 401:
//         router.push({ path: "/login" });
//         break;
//       case 500:
//         Message({
//           message: "服务器异常",
//           type: "error",
//         });
//         break;
//       case 403:
//         Message({
//           message: "您没有权限访问",
//           type: "error",
//           showClose: true,
//           duration: 5 * 1000,
//         });
//         break;
//       default:
//         break;
//     }
//   }
//   return Promise.reject(error);
// }
// ();

export const post = (url, params) => {
  return request({
    method: "post",
    url: url,
    data: { params },
  });
};
export const put = (url, params) => {
  return request({
    method: "put",
    url: url,
    data: params,
  });
};
export const get = (url, params) => {
  return request({
    method: "get",
    url: url,
    params: params,
  });
};
export const del = (url, params) => {
  return request({
    method: "delete",
    url: url,
    params: params,
  });
};

export const filedown = (url, params) => {
  return request({
    responseType: "blob",
    method: "get",
    url: url,
    params: params,
    headers: {
      "Content-Type": "application/pdf",
    },
  });
};
export default request;
